module.exports = __webpack_public_path__ + "static/img/MOOCS_VIDEO_BG.9430f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/MOOCS_VIDEO_BG.png
// module id = MVIe
// module chunks = 0